var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMaterial = function SvgMaterial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.375 3.35a.75.75 0 0 0-.75 0l-6.928 4a.75.75 0 0 0-.375.65v8a.75.75 0 0 0 .375.65l6.928 4a.75.75 0 0 0 .75 0l6.928-4a.75.75 0 0 0 .375-.65V8a.75.75 0 0 0-.375-.65zM11.25 5.3 6.572 8l4.678 2.701v-.576a.75.75 0 0 1 1.5 0v.576L17.428 8 12.75 5.3v1.075a.75.75 0 0 1-1.5 0zm1.5 7.957.52.28a.75.75 0 0 0 .71-1.321l-.44-.238L18.178 9.3v5.176l-.947-.51a.75.75 0 0 0-.712 1.32l1.111.598-4.88 2.818zm-2.29-1.279-.44.238a.75.75 0 0 0 .71 1.32l.52-.28v5.446l-4.88-2.818 1.11-.598a.75.75 0 0 0-.71-1.32l-.948.51V9.299z",
    clipRule: "evenodd"
  })));
};
export default SvgMaterial;